import LoadingGif from "@src/app/assets/lottie/loading.gif";
import { createMetaTags } from "@src/app/components/MetaTags/MetaTags";
import { useGsImageClickListener } from "@src/app/hooks/useGsImageClickListener";
import { useIsClient } from "@src/app/hooks/useIsClient";
import styles from "@src/app/styles/components/SiteSearch.css?url";
import { useEffect, useRef, useState } from "react";
import type { LinksFunction } from "react-router";

export const meta = () =>
  createMetaTags({
    title: "搜索结果 | 红蚂蚁",
    description: `红蚂蚁体积不大，能量却很大，它的触角和腿带刺毛，咬你一口，肯定让你痛得忘不了。本网站取名红蚂蚁，旨在学习蚂蚁灵活的脑袋和打架的本事，以生动的笔调撰写独立观点，以新颖的手法呈现新闻，让读者被咬得直呼过瘾。蚂蚁之所以"红"，因为它立足于"小红点"新加坡，触角伸向区域与世界，在思想的园地随意钻、认真咬。`,
    canonical: "https://www.redants.sg/sitesearch",
    robots: "noindex, nofollow",
  });

export const links: LinksFunction = () => [{ rel: "stylesheet", href: styles }];

export default function SiteSearchPage(): JSX.Element {
  const csePath = "https://cse.google.com/cse.js?cx=b2bc1b5e498634df8";
  const [isLoading, setIsLoading] = useState(true);
  const minLoadingTime = 800;
  const loadingStartTime = useRef(Date.now());

  const isClient = useIsClient();

  useGsImageClickListener(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  useEffect(() => {
    if (!isClient) return;

    loadingStartTime.current = Date.now();

    const script = document.createElement("script");
    script.src = csePath;
    script.async = true;

    const checkResults = () => {
      const searchBox = document.querySelector(".gsc-control-cse");

      const elapsedTime = Date.now() - loadingStartTime.current;

      if (elapsedTime >= minLoadingTime && searchBox) {
        setIsLoading(false);
      } else {
        requestAnimationFrame(checkResults);
      }
    };

    script.onload = () => {
      checkResults();
    };

    script.onerror = (error) => {
      setIsLoading(false);
      console.error("Failed to load Google Custom Search script:", error);
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [isClient]);

  return (
    <div className="flex flex-col items-center justify-center bg-secondary">
      <div className="mx-auto w-full lg:w-[800px]">
        {!isLoading && (
          <h1 className="pl-[12px] pt-[16px] text-header-2 text-primary">
            搜索结果
          </h1>
        )}
        <div className="relative min-h-[calc(100vh-380px)]">
          {isLoading && isClient && (
            <div className="absolute inset-0 z-10 flex min-h-[calc(100vh-380px)] w-full justify-center bg-secondary">
              <img src={LoadingGif} alt="" className="mt-4 h-16" />
            </div>
          )}
          {/* eslint-disable-next-line tailwindcss/no-custom-classname */}
          <div className="gcse-searchresults-only" />
        </div>
      </div>
    </div>
  );
}
